<template>
  <div class="footer-whole-page">
    <div class="footer-main">
      <div class="main-1">
        <div class="footer-icon"></div>
        <div class="main-title" style="margin-top: -0.8vw">珠海翼字科技有限公司</div>
        <div class="main-content">
          <span>邮箱：admin@ekwclass.com<br/></span>
          <span>电话：400-013-0021<br/></span>
          <div style="width: 15vw;display: flex;flex-direction: row;flex-wrap: nowrap;align-items: flex-end;justify-content: flex-start;height: 3vw;">
            <span style="display: inline-block;height: 3vw;margin-top: 0">地址：</span><span style="display: inline-block;width: 10vw;height: 3vw">珠海市高新区唐家湾镇天星五路159号4栋1层159号（集中办公区）</span>
          </div>

        </div>
      </div>
      <div class="main-2">
        <div class="main-title">产品</div>
        <div class="main-content">
          产品功能<br/>
        </div>
      </div>
      <div class="main-2" style="margin-right: 2vw">
        <div class="main-title">关于我们</div>
        <div class="main-content">
          了解我们<br/>
          加入我们<br/>
        </div>
      </div>
      <div class="main-line"></div>
      <div class="main-3">
        <div class="qr-code"></div>
        <div class="qr-text">扫码关注我们</div>
      </div>
    </div>
    <div class="footer-footer">
      Copyright © 2022 珠海翼字科技有限公司 | <a href="https://beian.miit.gov.cn" style="color: white">粤ICP备2022070444号-1</a>
    </div>
  </div>
</template>

<script>
export default {
  name:'Footer',
}
</script>

<style scoped>
.footer-whole-page{
  color:white;
  font-family: test;
  width:100vw;
  height: 20vw;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: flex-start;
  background-color: rgb(45,48,48);
}
.footer-main{
  height: 16vw;
  width: 100%;
  border-bottom: 1px #a0a0a0 solid;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-end;
}
.main-1{
  height: 90%;
  width: 15vw;
  margin-left: 10vw;
  margin-right: 15vw;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

}
.footer-icon{
  height: 3.5vw;
  width: 7vw;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/资源 4.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.main-title{
  font-size: 1.1vw;
  font-family: test;
  font-weight: 800;
  color: white;
  line-height: 3vw;
  height: 3vw;
  white-space: nowrap;
}
.main-content{
  position: relative;
  margin-top: 1vw;
  width: 15vw;
  font-size: 0.95vw;
  font-family: test;
  font-weight: normal;
  color: #a0a0a0;
  line-height: 1.5vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.main-2{
  height: 60%;
  width: 10vw;
  margin-right: 10vw;
  margin-bottom: 2vw;
}
.footer-footer{
  font-size: 0.8vw;
  line-height: 4vw;
  height: 4vw;
  width: 100%;
  text-align: center;
}
.main-3{
  width: 10vw;
  height: 10vw;
  display: flex;
  margin-bottom: 2vw;
  margin-left: 5vw;
  margin-right: 10vw;
  flex-direction: column;
}
.qr-code{
  margin-left: 1.5vw;
  background: url("http://data.xiyilab.com/web/main/static/首页/二维码.png") no-repeat center;
  background-size: contain;
  width: 7vw;
  height: 7vw;
}
.qr-text{
  line-height: 2.5vw;
  height: 2vw;
  text-align: center;
  font-size: 1vw;
  color: #a0a0a0;

}
.main-line{
  height: 80%;
  width: 1px;
  background-color: #a0a0a0;
  margin-bottom: 1.6vw;
}
</style>
